import previousOrders from "./previousOrders";

export default {
    previousOrders,
};
